import { useState, useEffect } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import InfiniteScroll from 'react-infinite-scroll-component'
import ListGroup from 'react-bootstrap/ListGroup'

import Spinner from './Spinner'
import ChevronRight from './icons/ChevronRight'

import sectionsApi from '../api/sectionsApi'
import { PER_PAGE } from './variables/variables'
import { normalizeServiceType } from '../utils/utils'

const SectionOption = (props) => {
  const [loading, setLoading] = useState(false)
  const [hasMore, setHasMore] = useState(true)
  const [sections, setSections] = useState([])
  const [currPage, setCurrPage] = useState(1)

  const fetchSections = async (page = 1) => {
    try {
      setLoading(true)
      const serviceType = normalizeServiceType(props.serviceType || props.trip.serviceType),
        status = props.status || props.trip.status

      const response = await sectionsApi.getSectionsByServiceType({perPage: PER_PAGE, page: page,
        serviceType: serviceType, status: status, tripId: props.tripId})

      if (response?.status) {
        setSections([...sections, ...response.data])
        setCurrPage(page + 1)
        setHasMore(response.data.length > PER_PAGE)
      }

    } catch (error) {
      console.error(error)
    } finally {
      setLoading(false)
    }
}

useEffect(() =>{
    fetchSections()
  }, [])

  if (loading) return <Spinner />
  return (
    <ListGroup variant='flush' >
      <InfiniteScroll
        dataLength={currPage * PER_PAGE}
        next={() => fetchSections(currPage)}
        hasMore={hasMore}
        loader={<h6>Loading...</h6>}
      >
        {sections?.map((section) => (
          <NavLink
            to={`/trip/${props.tripId}/sections/${section.id}`}
            style={{ textDecoration: 'none' }}
            key={section.id}
            state={{
              topic: section,
              serviceType: normalizeServiceType(props.serviceType || props.trip.serviceType),
              status: props.status || props.trip.status
            }}
          >
            <ListGroup variant='flush'>
              <ListGroup.Item
                variant='flush'
                className='topicOptions alignTextDiffSize grey'
                style={{
                  fontFamily:
                    props.fontWeight === 'semibold'
                      ? 'Open Sans Semi-Bold'
                      : 'Open Sans Bold',
                }}
              >
                <div
                  style={{
                    marginTop: 'auto',
                    marginBottom: 'auto',
                    paddingRight: '15px',
                  }}
                >
                  {
                    <img
                      src={section.imagePath}
                      width='40px'
                      height='40px'
                      style={{ marginRight: '10px', padding: "2px" }}
                      alt=''
                    />
                  }
                  {section.name}
                </div>
                <div style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                  <ChevronRight size='12' fill='#D8D8D8' />
                </div>
              </ListGroup.Item>
              <ListGroup.Item style={{ padding: '1px' }} />
            </ListGroup>
          </NavLink>
        ))}
      </InfiniteScroll>
    </ListGroup>
  )
}

export default SectionOption
